import { useState } from 'react';
import { useTheme, jsx } from '@emotion/react';
import '@babel/runtime/helpers/extends';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';
import ArrowIcon from '../../icons/icons/arrowIcon.js';
import { OffClickWrapper } from '../offClickWrapper/index.js';
import Style from './style.js';

var Tooltip = _ref => {
  var {
    alignRightPercent = 0,
    alignTopPercent = 0,
    arrowAlign = 'middle',
    children,
    content = '',
    defaultOpen = false,
    display = true,
    hasRestrictedWidth = false,
    isSmall = false,
    nudgeBottom = 0,
    nudgeLeft = 0,
    nudgeRight = 0,
    nudgeTop = 0,
    position = 'top'
  } = _ref;
  var theme = useTheme();
  var [clicked, setClicked] = useState(false);
  var [hovered, setHovered] = useState(false);

  var onClick = () => {
    setClicked(!clicked);
  };

  var closeTooltip = () => {
    setClicked(false);
    setHovered(false);
  };

  var open = defaultOpen || clicked || hovered;
  return jsx(OffClickWrapper, {
    onOffClick: closeTooltip
  }, jsx(Style.MainContainer, null, jsx(Style.Trigger, {
    onClick: onClick,
    onMouseEnter: () => {
      setHovered(true);
    },
    onMouseLeave: () => {
      setHovered(false);
    }
  }, children), jsx(Style.TooltipBox, {
    alignRightPercent: alignRightPercent,
    alignTopPercent: alignTopPercent,
    arrowAlign: arrowAlign,
    onClick: open ? onClick : undefined,
    displayTooltip: display,
    hasRestrictedWidth: hasRestrictedWidth,
    isSmall: isSmall,
    nudgeBottom: nudgeBottom,
    nudgeLeft: nudgeLeft,
    nudgeRight: nudgeRight,
    nudgeTop: nudgeTop,
    open: open,
    position: position
  }, jsx(Style.TooltipContent, null, content), jsx(Style.ArrowImageContainer, {
    arrowAlign: arrowAlign,
    position: position
  }, jsx(ArrowIcon, {
    width: 16,
    height: 16,
    fill: theme.COLORS.primary
  })))));
};

export { Tooltip };
